<template>
  <span class="n-icon">
    <svg viewBox="0 0 24 24">
      <path :fill="fill" d="M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" />
    </svg>
  </span>
</template>
<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-file-icon',
});
</script>
